import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProspectService extends ApiService {

  constructor(private http: HttpClient) {
    super(http);
    this.apiURL += '/prospects';
  }
}